import { isEmpty } from "lodash";
import { getSubscriptionPlanType } from "components/subscriptions/CurrentPlanInformation";
import useLocalStorage from "./useLocalStorage";
import { useEffect, useState } from "react";

export const useSubscriptionLocalStorage = () => {
    const { setLocalStorageStateValue } = useLocalStorage({
        key: "subscriptionPlanType",
        defaultValue: "",
    });
    const [localStorageSubscription, setLocalStorageSubscription] =
        useState<any>({});

    useEffect(() => {
        if (
            localStorageSubscription === undefined ||
            isEmpty(localStorageSubscription)
        )
            return;
        const {
            customer: { is_prepaid, is_cancellable },
        } = localStorageSubscription;
        const subscriptionType = getSubscriptionPlanType({
            is_prepaid,
            is_cancellable,
        });
        setLocalStorageStateValue(subscriptionType);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorageSubscription.uuid]);

    return { setLocalStorageSubscription };
};
